import { render, staticRenderFns } from "./WeekdayPerformanceChart.vue?vue&type=template&id=b41ff060"
import script from "./WeekdayPerformanceChart.vue?vue&type=script&lang=js"
export * from "./WeekdayPerformanceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports